import React from "react";
import { useTranslation } from "react-i18next";
import LegalLayout from "./LegalLayout";

export default function Terms() {
  const { i18n } = useTranslation();
  const isTh = i18n.language?.startsWith("th") ?? true;

  const sections = isTh
    ? [
        {
          h: "1. การยอมรับเงื่อนไข",
          p: "การเข้าใช้งานเว็บไซต์นี้ถือว่าท่านได้อ่าน เข้าใจ และตกลงตามข้อกำหนดและเงื่อนไขทั้งหมดแล้ว หากท่านไม่ตกลงตามข้อกำหนดเหล่านี้ โปรดงดใช้งานเว็บไซต์",
        },
        {
          h: "2. การใช้งานเว็บไซต์",
          p: "ท่านตกลงที่จะใช้งานเว็บไซต์นี้เพื่อวัตถุประสงค์ที่ถูกต้องตามกฎหมาย และจะไม่ใช้งานในลักษณะที่อาจสร้างความเสียหายต่อเว็บไซต์ หรือสิทธิของบุคคลอื่น",
        },
        {
          h: "3. ทรัพย์สินทางปัญญา",
          p: "เนื้อหา ภาพ และเครื่องหมายการค้าทั้งหมดที่ปรากฏบนเว็บไซต์เป็นทรัพย์สินทางปัญญาของ บริษัท ไทย แทคซ์ แอนด์ ลอว์ จำกัด ห้ามคัดลอก ดัดแปลง หรือนำไปใช้ในเชิงพาณิชย์โดยมิได้รับอนุญาตเป็นลายลักษณ์อักษร",
        },
        {
          h: "4. ความสัมพันธ์ทางวิชาชีพ",
          p: "การเข้าใช้งานเว็บไซต์หรือการติดต่อสอบถามเบื้องต้นยังไม่ก่อให้เกิดความสัมพันธ์ทางวิชาชีพระหว่างท่านกับสำนักงาน ความสัมพันธ์ดังกล่าวจะเกิดขึ้นต่อเมื่อมีการตกลงในการให้บริการเป็นลายลักษณ์อักษร",
        },
        {
          h: "5. การจำกัดความรับผิด",
          p: "เนื้อหาบนเว็บไซต์มีลักษณะเป็นข้อมูลทั่วไป มิใช่คำปรึกษาทางกฎหมายเฉพาะกรณี การนำข้อมูลไปใช้โดยมิได้ปรึกษาทนายความถือเป็นความเสี่ยงของท่านเอง สำนักงานไม่รับผิดชอบต่อความเสียหายที่เกิดจากการใช้ข้อมูลในลักษณะดังกล่าว",
        },
        {
          h: "6. กฎหมายที่ใช้บังคับ",
          p: "ข้อกำหนดและเงื่อนไขนี้อยู่ภายใต้บังคับกฎหมายแห่งราชอาณาจักรไทย และข้อพิพาทที่เกิดขึ้นจะถูกพิจารณาโดยศาลไทยที่มีเขตอำนาจ",
        },
      ]
    : [
        {
          h: "1. Acceptance of Terms",
          p: "By using this website you confirm that you have read, understood, and agreed to all terms and conditions. If you disagree, please refrain from using the site.",
        },
        {
          h: "2. Site Use",
          p: "You agree to use this site only for lawful purposes, and not in any way that could damage the site or the rights of others.",
        },
        {
          h: "3. Intellectual Property",
          p: "All content, images, and trademarks on this site are the intellectual property of Thai Tax & Law Co., Ltd. Copying, modification, or commercial use without written permission is prohibited.",
        },
        {
          h: "4. Professional Relationship",
          p: "Visiting the site or making an initial inquiry does not create a professional relationship with the firm. Such a relationship arises only upon a written engagement agreement.",
        },
        {
          h: "5. Limitation of Liability",
          p: "Content on this site is general information, not specific legal advice. Acting on it without consulting a lawyer is at your own risk. The firm accepts no liability for damage arising from such use.",
        },
        {
          h: "6. Governing Law",
          p: "These terms are governed by Thai law, and any dispute will be heard by a Thai court of competent jurisdiction.",
        },
      ];

  return (
    <LegalLayout
      title={isTh ? "ข้อกำหนดและเงื่อนไขการใช้งาน" : "Terms of Use"}
      subtitle={isTh ? "Terms of Use" : "Terms and Conditions"}
      lastUpdated={isTh ? "ปรับปรุงล่าสุด: 11 พฤษภาคม 2569" : "Last Updated: May 11, 2026"}
      sections={sections}
    />
  );
}
